
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $9b05bcda60cc529c$exports = {};

$parcel$export($9b05bcda60cc529c$exports, "likeNull", function () { return $9b05bcda60cc529c$export$61cc6ed0f143570b; });
$parcel$export($9b05bcda60cc529c$exports, "isEmpty", function () { return $9b05bcda60cc529c$export$dd1bc94b04021eeb; });
$parcel$export($9b05bcda60cc529c$exports, "classNameOf", function () { return $9b05bcda60cc529c$export$a09f818797e212c4; });
$parcel$export($9b05bcda60cc529c$exports, "assertInheritance", function () { return $9b05bcda60cc529c$export$170f4e08cad8229d; });
$parcel$export($9b05bcda60cc529c$exports, "proxyPrototype", function () { return $9b05bcda60cc529c$export$2a489b3f92f4996a; });
$parcel$export($9b05bcda60cc529c$exports, "isUnsafeNumeric", function () { return $9b05bcda60cc529c$export$67a6ce548ae77071; });
$parcel$export($9b05bcda60cc529c$exports, "byteLength", function () { return $9b05bcda60cc529c$export$a48f0734ac7c2329; });
$parcel$export($9b05bcda60cc529c$exports, "toHyphenCase", function () { return $9b05bcda60cc529c$export$3f34ca2fef821bbd; });
$parcel$export($9b05bcda60cc529c$exports, "toCamelCase", function () { return $9b05bcda60cc529c$export$86f54f62aa7a7514; });
$parcel$export($9b05bcda60cc529c$exports, "uniqueID", function () { return $9b05bcda60cc529c$export$89912e019eef22aa; });
$parcel$export($9b05bcda60cc529c$exports, "objectFrom", function () { return $9b05bcda60cc529c$export$1c8ba402144543e5; });
$parcel$export($9b05bcda60cc529c$exports, "DiffStatus", function () { return $9b05bcda60cc529c$export$2ddabb89308e1a22; });
$parcel$export($9b05bcda60cc529c$exports, "diffKeys", function () { return $9b05bcda60cc529c$export$14527669107aa301; });
$parcel$export($9b05bcda60cc529c$exports, "groupBy", function () { return $9b05bcda60cc529c$export$3f063810d7bf01bd; });
$parcel$export($9b05bcda60cc529c$exports, "likeArray", function () { return $9b05bcda60cc529c$export$b5a4d6f439a5044d; });
$parcel$export($9b05bcda60cc529c$exports, "isTypedArray", function () { return $9b05bcda60cc529c$export$b119cc7e1840e59c; });
$parcel$export($9b05bcda60cc529c$exports, "makeArray", function () { return $9b05bcda60cc529c$export$7b85fd78dd236198; });
$parcel$export($9b05bcda60cc529c$exports, "splitArray", function () { return $9b05bcda60cc529c$export$697c3df919c0e61a; });
$parcel$export($9b05bcda60cc529c$exports, "findDeep", function () { return $9b05bcda60cc529c$export$e6b5ff3168b5942b; });
$parcel$export($9b05bcda60cc529c$exports, "countBy", function () { return $9b05bcda60cc529c$export$1d012a0dff3dab06; });
$parcel$export($9b05bcda60cc529c$exports, "cache", function () { return $9b05bcda60cc529c$export$69a3209f1a06c04d; });
$parcel$export($9b05bcda60cc529c$exports, "createAsyncIterator", function () { return $9b05bcda60cc529c$export$86c18c6347f4a8c4; });
$parcel$export($9b05bcda60cc529c$exports, "mergeStream", function () { return $9b05bcda60cc529c$export$dce9414bed0662c; });
$parcel$export($9b05bcda60cc529c$exports, "ByteSize", function () { return $9b05bcda60cc529c$export$271f7c16f175f804; });
var $6a9944941b4c1893$exports = {};

$parcel$export($6a9944941b4c1893$exports, "sum", function () { return $6a9944941b4c1893$export$8a63f25cc62965f1; });
$parcel$export($6a9944941b4c1893$exports, "averageOf", function () { return $6a9944941b4c1893$export$e1f36757ecda301d; });
$parcel$export($6a9944941b4c1893$exports, "varianceOf", function () { return $6a9944941b4c1893$export$8e694e1eafd55acb; });
$parcel$export($6a9944941b4c1893$exports, "standardDeviationOf", function () { return $6a9944941b4c1893$export$57d7c52a66287430; });
$parcel$export($6a9944941b4c1893$exports, "hypotenuseOf", function () { return $6a9944941b4c1893$export$2b4693832ca3ce16; });
$parcel$export($6a9944941b4c1893$exports, "carryFloat", function () { return $6a9944941b4c1893$export$5b784e078da1ce6; });
$parcel$export($6a9944941b4c1893$exports, "fixFloat", function () { return $6a9944941b4c1893$export$17ec9c9f4f23588c; });
$parcel$export($6a9944941b4c1893$exports, "Scalar", function () { return $6a9944941b4c1893$export$595dbf49c602a1f; });
function $6a9944941b4c1893$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $6a9944941b4c1893$export$e1f36757ecda301d(...data) {
    return $6a9944941b4c1893$export$8a63f25cc62965f1(...data) / data.length;
}
function $6a9944941b4c1893$export$8e694e1eafd55acb(data, sample = false) {
    const average = $6a9944941b4c1893$export$e1f36757ecda301d(...data);
    const summary = $6a9944941b4c1893$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $6a9944941b4c1893$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($6a9944941b4c1893$export$8e694e1eafd55acb(data, sample));
}
function $6a9944941b4c1893$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($6a9944941b4c1893$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $6a9944941b4c1893$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf(".") + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
function $6a9944941b4c1893$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf(".");
    if (floatOffset < 0) return length ? `${text}.${"0".repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $6a9944941b4c1893$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
class $6a9944941b4c1893$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}


function $9b05bcda60cc529c$export$61cc6ed0f143570b(value) {
    return !(value != null) || Number.isNaN(value);
}
function $9b05bcda60cc529c$export$dd1bc94b04021eeb(value) {
    return $9b05bcda60cc529c$export$61cc6ed0f143570b(value) || (typeof value === "object" ? !Object.keys(value).length : value === "");
}
const $9b05bcda60cc529c$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
function $9b05bcda60cc529c$export$170f4e08cad8229d(Sub, Super) {
    return Sub.prototype instanceof Super;
}
function $9b05bcda60cc529c$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
function $9b05bcda60cc529c$export$67a6ce548ae77071(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + "", undefined, {
        numeric: true
    }) > 0;
}
function $9b05bcda60cc529c$export$a48f0734ac7c2329(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, "xx").length;
}
function $9b05bcda60cc529c$export$3f34ca2fef821bbd(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? "-" : ""}${(match[1] || match[0]).toLowerCase()}`);
}
function $9b05bcda60cc529c$export$86f54f62aa7a7514(raw, large = false) {
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
}
function $9b05bcda60cc529c$export$89912e019eef22aa() {
    return (Date.now() + parseInt((Math.random() + "").slice(2))).toString(36);
}
function $9b05bcda60cc529c$export$1c8ba402144543e5(values, keys) {
    return Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
}
var $9b05bcda60cc529c$export$2ddabb89308e1a22;
(function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
})($9b05bcda60cc529c$export$2ddabb89308e1a22 || ($9b05bcda60cc529c$export$2ddabb89308e1a22 = {}));
function $9b05bcda60cc529c$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = -1;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += 1;
    }
    return {
        map: map,
        group: $9b05bcda60cc529c$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $9b05bcda60cc529c$export$b5a4d6f439a5044d(data) {
    if ($9b05bcda60cc529c$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === "number" && length >= 0 && ~~length === length;
}
const $9b05bcda60cc529c$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $9b05bcda60cc529c$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($9b05bcda60cc529c$export$61cc6ed0f143570b(data)) return [];
    if ($9b05bcda60cc529c$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $9b05bcda60cc529c$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $9b05bcda60cc529c$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $9b05bcda60cc529c$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $9b05bcda60cc529c$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $9b05bcda60cc529c$export$1d012a0dff3dab06(list, iteratee) {
    const group = $9b05bcda60cc529c$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $9b05bcda60cc529c$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $9b05bcda60cc529c$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol("done"), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $9b05bcda60cc529c$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $9b05bcda60cc529c$export$271f7c16f175f804 extends (0, $6a9944941b4c1893$export$595dbf49c602a1f) {
    constructor(...args){
        super(...args);
        this.units = [
            "",
            "K",
            "M",
            "G",
            "T",
            "P",
            "E",
            "Z",
            "Y"
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + "B"
            }));
    }
}



var $f872d8bba1c0f79f$exports = {};

$parcel$export($f872d8bba1c0f79f$exports, "Second", function () { return $f872d8bba1c0f79f$export$c489aa6f7fd82b1a; });
$parcel$export($f872d8bba1c0f79f$exports, "Minute", function () { return $f872d8bba1c0f79f$export$cbd942915f33be50; });
$parcel$export($f872d8bba1c0f79f$exports, "Quarter", function () { return $f872d8bba1c0f79f$export$9b886f8493244014; });
$parcel$export($f872d8bba1c0f79f$exports, "Hour", function () { return $f872d8bba1c0f79f$export$e99cbb807a5bb10d; });
$parcel$export($f872d8bba1c0f79f$exports, "Day", function () { return $f872d8bba1c0f79f$export$7a9a31a911eb9a20; });
$parcel$export($f872d8bba1c0f79f$exports, "Week", function () { return $f872d8bba1c0f79f$export$fca4f8121099df57; });
$parcel$export($f872d8bba1c0f79f$exports, "Year", function () { return $f872d8bba1c0f79f$export$6ce2f08d515512; });
$parcel$export($f872d8bba1c0f79f$exports, "Month", function () { return $f872d8bba1c0f79f$export$951c8378cdfec6e6; });
$parcel$export($f872d8bba1c0f79f$exports, "Season", function () { return $f872d8bba1c0f79f$export$1a4097b876a13bf7; });
$parcel$export($f872d8bba1c0f79f$exports, "Timestamp", function () { return $f872d8bba1c0f79f$export$d9bcbd5e1ff81430; });
$parcel$export($f872d8bba1c0f79f$exports, "diffTime", function () { return $f872d8bba1c0f79f$export$506c8e8f8c8edda; });
$parcel$export($f872d8bba1c0f79f$exports, "formatDate", function () { return $f872d8bba1c0f79f$export$3ae94a2503e890a1; });
$parcel$export($f872d8bba1c0f79f$exports, "changeMonth", function () { return $f872d8bba1c0f79f$export$62ad822b3a5fd9a0; });

const $f872d8bba1c0f79f$export$c489aa6f7fd82b1a = 1000;
const $f872d8bba1c0f79f$export$cbd942915f33be50 = $f872d8bba1c0f79f$export$c489aa6f7fd82b1a * 60;
const $f872d8bba1c0f79f$export$9b886f8493244014 = $f872d8bba1c0f79f$export$cbd942915f33be50 * 15;
const $f872d8bba1c0f79f$export$e99cbb807a5bb10d = $f872d8bba1c0f79f$export$9b886f8493244014 * 4;
const $f872d8bba1c0f79f$export$7a9a31a911eb9a20 = $f872d8bba1c0f79f$export$e99cbb807a5bb10d * 24;
const $f872d8bba1c0f79f$export$fca4f8121099df57 = $f872d8bba1c0f79f$export$7a9a31a911eb9a20 * 7;
const $f872d8bba1c0f79f$export$6ce2f08d515512 = $f872d8bba1c0f79f$export$7a9a31a911eb9a20 * 365;
const $f872d8bba1c0f79f$export$951c8378cdfec6e6 = $f872d8bba1c0f79f$export$6ce2f08d515512 / 12;
const $f872d8bba1c0f79f$export$1a4097b876a13bf7 = $f872d8bba1c0f79f$export$951c8378cdfec6e6 * 3;
class $f872d8bba1c0f79f$export$d9bcbd5e1ff81430 extends (0, $6a9944941b4c1893$export$595dbf49c602a1f) {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args);
        this.units = [
            {
                base: $f872d8bba1c0f79f$export$c489aa6f7fd82b1a,
                name: "s"
            },
            {
                base: $f872d8bba1c0f79f$export$cbd942915f33be50,
                name: "m"
            },
            {
                base: $f872d8bba1c0f79f$export$e99cbb807a5bb10d,
                name: "H"
            },
            {
                base: $f872d8bba1c0f79f$export$7a9a31a911eb9a20,
                name: "D"
            },
            {
                base: $f872d8bba1c0f79f$export$fca4f8121099df57,
                name: "W"
            },
            {
                base: $f872d8bba1c0f79f$export$951c8378cdfec6e6,
                name: "M"
            },
            {
                base: $f872d8bba1c0f79f$export$6ce2f08d515512,
                name: "Y"
            }
        ];
    }
}
function $f872d8bba1c0f79f$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $f872d8bba1c0f79f$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + "";
    return (template)=>(value.length < template.length ? value.padStart(template.length, "0") : value).slice(-Math.max(template.length, 2));
}
function $f872d8bba1c0f79f$export$3ae94a2503e890a1(time = new Date(), template = "YYYY-MM-DD HH:mm:ss") {
    time = time instanceof Date ? time : new Date(time);
    time = new Date(+time - time.getTimezoneOffset() * $f872d8bba1c0f79f$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = time.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $f872d8bba1c0f79f$var$fitUnit(second));
}
function $f872d8bba1c0f79f$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date.setFullYear(date.getFullYear() + Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}


var $ba0e5dc395660a7c$exports = {};

$parcel$export($ba0e5dc395660a7c$exports, "parseJSON", function () { return $ba0e5dc395660a7c$export$27924e57e9afff7f; });
$parcel$export($ba0e5dc395660a7c$exports, "toJSValue", function () { return $ba0e5dc395660a7c$export$7ea17d45ecdcf634; });
$parcel$export($ba0e5dc395660a7c$exports, "parseTextTable", function () { return $ba0e5dc395660a7c$export$bb8626e4916f587b; });

function $ba0e5dc395660a7c$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === "string" && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== "string" || (0, $9b05bcda60cc529c$export$67a6ce548ae77071)(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $ba0e5dc395660a7c$export$7ea17d45ecdcf634(raw) {
    const parsed = $ba0e5dc395660a7c$export$27924e57e9afff7f(raw);
    if (typeof parsed !== "string") return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + "" !== parsed ? parsed : number;
}
function $ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $ba0e5dc395660a7c$export$bb8626e4916f587b(raw, header, separator = ",") {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>{
        const list = [];
        do {
            let value;
            if (row[0] === '"' || row[0] === "'") {
                value = $ba0e5dc395660a7c$var$readQuoteValue(row);
                row = row.slice(value.length + 3);
            } else {
                const index = row.indexOf(separator);
                if (index > -1) {
                    value = row.slice(0, index);
                    row = row.slice(index + 1);
                } else {
                    value = row;
                    row = "";
                }
            }
            list.push($ba0e5dc395660a7c$export$7ea17d45ecdcf634(value.trim()));
        }while (row);
        return list;
    });
    return !header ? data : data.slice(1).map((row)=>row.reduce((object, item, index)=>{
            object[data[0][index]] = item;
            return object;
        }, {}));
}


var $083124ac4b1a50a0$exports = {};

$parcel$export($083124ac4b1a50a0$exports, "isXDomain", function () { return $083124ac4b1a50a0$export$71e6483fc2b024eb; });
$parcel$export($083124ac4b1a50a0$exports, "parseURLData", function () { return $083124ac4b1a50a0$export$eb9b2aadbe449a20; });
$parcel$export($083124ac4b1a50a0$exports, "buildURLData", function () { return $083124ac4b1a50a0$export$13397a83aa5915d6; });
$parcel$export($083124ac4b1a50a0$exports, "blobOf", function () { return $083124ac4b1a50a0$export$fd89523fba250fa4; });
$parcel$export($083124ac4b1a50a0$exports, "blobFrom", function () { return $083124ac4b1a50a0$export$504fbde693c1771c; });


function $083124ac4b1a50a0$export$71e6483fc2b024eb(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
}
function $083124ac4b1a50a0$export$eb9b2aadbe449a20(raw = globalThis.location?.search, toBuiltIn = true) {
    const list = raw.split(/\?|#/);
    const data = new URLSearchParams(list[1] || list[0]);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map((0, $ba0e5dc395660a7c$export$27924e57e9afff7f)) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $083124ac4b1a50a0$var$stringify = (value)=>typeof value === "string" ? value : (0, $9b05bcda60cc529c$export$b5a4d6f439a5044d)(value) ? (0, $9b05bcda60cc529c$export$7b85fd78dd236198)(value) + "" : JSON.stringify(value);
function $083124ac4b1a50a0$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!(0, $9b05bcda60cc529c$export$dd1bc94b04021eeb)(value) && [
            key,
            $083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
async function $083124ac4b1a50a0$export$fd89523fba250fa4(URI) {
    return (await fetch(URI + "")).blob();
}
const $083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $083124ac4b1a50a0$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = new ArrayBuffer(data.length);
    const uBuffer = new Uint8Array(aBuffer);
    for(let i = 0; data[i]; i++)uBuffer[i] = data.charCodeAt(i);
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}


var $50872bf213056663$exports = {};

$parcel$export($50872bf213056663$exports, "makeCRC32", function () { return $50872bf213056663$export$1b9ac4d3de3ffd2e; });
$parcel$export($50872bf213056663$exports, "makeSHA", function () { return $50872bf213056663$export$d51f3b55e8d1aa73; });
const $50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $50872bf213056663$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return "0x" + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === "object") {
    if ("msCrypto" in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.["webkitSubtle"]) // @ts-ignore
    crypto1.subtle = crypto1["webkitSubtle"];
}
async function $50872bf213056663$export$d51f3b55e8d1aa73(raw, algorithm = "SHA-1") {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, "0")).join("");
}


var $93a3089d2937b23f$exports = {};


var $3e0a089cc13f69ad$exports = {};

$parcel$export($3e0a089cc13f69ad$exports, "XMLNamespace", function () { return $3e0a089cc13f69ad$export$f5a4056b78c72efa; });
$parcel$export($3e0a089cc13f69ad$exports, "templateOf", function () { return $3e0a089cc13f69ad$export$2ee022bbbc550b25; });
$parcel$export($3e0a089cc13f69ad$exports, "elementTypeOf", function () { return $3e0a089cc13f69ad$export$a549dd5cef7f8327; });
$parcel$export($3e0a089cc13f69ad$exports, "isHTMLElementClass", function () { return $3e0a089cc13f69ad$export$8eece510bcb9c62c; });
$parcel$export($3e0a089cc13f69ad$exports, "tagNameOf", function () { return $3e0a089cc13f69ad$export$b8a1af58c024fefd; });
$parcel$export($3e0a089cc13f69ad$exports, "isDOMReadOnly", function () { return $3e0a089cc13f69ad$export$a2cf0d4bb6e06de4; });
$parcel$export($3e0a089cc13f69ad$exports, "parseDOM", function () { return $3e0a089cc13f69ad$export$d66b332881d9723f; });
$parcel$export($3e0a089cc13f69ad$exports, "stringifyDOM", function () { return $3e0a089cc13f69ad$export$b0709844452f8b6b; });
$parcel$export($3e0a089cc13f69ad$exports, "walkDOM", function () { return $3e0a089cc13f69ad$export$5118471ee5d5453b; });
$parcel$export($3e0a089cc13f69ad$exports, "getVisibleText", function () { return $3e0a089cc13f69ad$export$be4650432daa84fd; });
$parcel$export($3e0a089cc13f69ad$exports, "splitPages", function () { return $3e0a089cc13f69ad$export$578e38b4a3e0b255; });
$parcel$export($3e0a089cc13f69ad$exports, "importCSS", function () { return $3e0a089cc13f69ad$export$7cd14c57bbb84350; });
$parcel$export($3e0a089cc13f69ad$exports, "stringifyCSS", function () { return $3e0a089cc13f69ad$export$5100419dfae0456d; });
$parcel$export($3e0a089cc13f69ad$exports, "insertToCursor", function () { return $3e0a089cc13f69ad$export$28d9d24a8cd0ffc2; });
$parcel$export($3e0a089cc13f69ad$exports, "scrollTo", function () { return $3e0a089cc13f69ad$export$3f99968195accfaf; });
$parcel$export($3e0a089cc13f69ad$exports, "watchScroll", function () { return $3e0a089cc13f69ad$export$eafdbaa868ea9975; });
$parcel$export($3e0a089cc13f69ad$exports, "watchVisible", function () { return $3e0a089cc13f69ad$export$36a0c1ca2ae264fa; });
$parcel$export($3e0a089cc13f69ad$exports, "formToJSON", function () { return $3e0a089cc13f69ad$export$86d7c59254d6a2c9; });


const $3e0a089cc13f69ad$export$f5a4056b78c72efa = {
    html: "http://www.w3.org/1999/xhtml",
    svg: "http://www.w3.org/2000/svg",
    math: "http://www.w3.org/1998/Math/MathML"
};
const $3e0a089cc13f69ad$var$templateMap = {};
function $3e0a089cc13f69ad$export$2ee022bbbc550b25(tagName) {
    if ($3e0a089cc13f69ad$var$templateMap[tagName]) return $3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement("template");
    spawn.innerHTML = `<${tagName} />`;
    return $3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $3e0a089cc13f69ad$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes("-")) return "html";
    const [prefix, localName] = tagName.split(":");
    if (localName) return prefix === "html" ? "html" : "xml";
    const node = $3e0a089cc13f69ad$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? "html" : "xml";
}
function $3e0a089cc13f69ad$export$8eece510bcb9c62c(Class) {
    return (0, $9b05bcda60cc529c$export$170f4e08cad8229d)(Class, HTMLElement);
}
const $3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $3e0a089cc13f69ad$export$b8a1af58c024fefd(Class) {
    const name = $3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $3e0a089cc13f69ad$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                "sizes"
            ]
        ],
        [
            HTMLIFrameElement,
            [
                "sandbox"
            ]
        ],
        [
            HTMLObjectElement,
            [
                "form"
            ]
        ],
        [
            HTMLInputElement,
            [
                "form",
                "list"
            ]
        ],
        [
            HTMLButtonElement,
            [
                "form"
            ]
        ],
        [
            HTMLSelectElement,
            [
                "form"
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                "form"
            ]
        ],
        [
            HTMLOutputElement,
            [
                "form"
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                "form"
            ]
        ]
    ];
    const template = $3e0a089cc13f69ad$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $3e0a089cc13f69ad$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement("template");
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
function $3e0a089cc13f69ad$export$b0709844452f8b6b(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, "");
}
function* $3e0a089cc13f69ad$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ((0, $9b05bcda60cc529c$export$dd1bc94b04021eeb)(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $3e0a089cc13f69ad$export$5118471ee5d5453b(node, type);
}
function $3e0a089cc13f69ad$export$be4650432daa84fd(root) {
    var text = "";
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $3e0a089cc13f69ad$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute("aria-hidden") !== "true") {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, " ");
    }
    return text;
}
function $3e0a089cc13f69ad$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $3e0a089cc13f69ad$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement("link");
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? "alternate " : "") + "stylesheet";
        link.href = URI;
        document.head.append(link);
    });
}
function $3e0a089cc13f69ad$export$5100419dfae0456d(data, depth = 0, indent = "    ") {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== "object" ? `${padding}${(0, $9b05bcda60cc529c$export$3f34ca2fef821bbd)(key)}: ${value};` : `${padding}${key} {
${$3e0a089cc13f69ad$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join("\n");
}
function $3e0a089cc13f69ad$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $3e0a089cc13f69ad$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        "meta",
        "title",
        "link",
        "script"
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $3e0a089cc13f69ad$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === "top") window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: "smooth",
        block: align,
        inline: justify
    });
}
function $3e0a089cc13f69ad$export$eafdbaa868ea9975(box, handler, depth = 6) {
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ""), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, "-");
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
}
function $3e0a089cc13f69ad$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === "visible" ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener("visibilitychange", ()=>change(document.visibilityState === "visible" ? last | 1 : last & 2));
}
function $3e0a089cc13f69ad$export$86d7c59254d6a2c9(form) {
    const data = {};
    for (const field of form.elements){
        let { name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        const type = field.type;
        if (!name || value === "") continue;
        const box = type !== "fieldset" && field.closest("fieldset");
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case "radio":
            case "checkbox":
                if (checked) parsedValue = defaultValue ? (0, $ba0e5dc395660a7c$export$7ea17d45ecdcf634)(defaultValue) : true;
                else continue;
                break;
            case "select-multiple":
                parsedValue = Array.from(selectedOptions, ({ value: value })=>(0, $ba0e5dc395660a7c$export$7ea17d45ecdcf634)(value));
                break;
            case "fieldset":
                parsedValue = $3e0a089cc13f69ad$export$86d7c59254d6a2c9(field);
                break;
            case "file":
                parsedValue = files && Array.from(files);
                break;
            case "date":
            case "datetime-local":
            case "month":
            case "hidden":
            case "number":
            case "range":
            case "select-one":
                parsedValue = (0, $ba0e5dc395660a7c$export$7ea17d45ecdcf634)(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !(0, $9b05bcda60cc529c$export$dd1bc94b04021eeb)(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}


var $bb23e0c794fefbef$exports = {};

$parcel$export($bb23e0c794fefbef$exports, "sleep", function () { return $bb23e0c794fefbef$export$e772c8ff12451969; });
$parcel$export($bb23e0c794fefbef$exports, "asyncLoop", function () { return $bb23e0c794fefbef$export$57207d71b8c929c8; });
function $bb23e0c794fefbef$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $bb23e0c794fefbef$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $bb23e0c794fefbef$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}


var $19ed8aeb7905a045$exports = {};

$parcel$export($19ed8aeb7905a045$exports, "delegate", function () { return $19ed8aeb7905a045$export$10b1921597150314; });
$parcel$export($19ed8aeb7905a045$exports, "documentReady", function () { return $19ed8aeb7905a045$export$3e2b244719956741; });
$parcel$export($19ed8aeb7905a045$exports, "promisify", function () { return $19ed8aeb7905a045$export$1d1d2ed6b55cf67f; });
$parcel$export($19ed8aeb7905a045$exports, "createMessageServer", function () { return $19ed8aeb7905a045$export$2155c0b5a4b77fb8; });
$parcel$export($19ed8aeb7905a045$exports, "createMessageClient", function () { return $19ed8aeb7905a045$export$9d97473344489dfc; });
$parcel$export($19ed8aeb7905a045$exports, "serviceWorkerUpdate", function () { return $19ed8aeb7905a045$export$d635d04af3887bbe; });

function $19ed8aeb7905a045$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $19ed8aeb7905a045$export$3e2b244719956741 = typeof window !== "undefined" ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener("DOMContentLoaded", done);
        window.removeEventListener("load", done);
        resolve();
    }
    document?.addEventListener("DOMContentLoaded", done);
    window.addEventListener("load", done);
    setTimeout(function check() {
        document?.readyState === "complete" ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $19ed8aeb7905a045$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + "end", end);
            element.removeEventListener(scope + "cancel", cancel);
        }
        element.addEventListener(scope + "end", end);
        element.addEventListener(scope + "cancel", cancel);
    });
}
function $19ed8aeb7905a045$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener("message", server);
    return ()=>globalThis.removeEventListener("message", server);
}
function $19ed8aeb7905a045$export$9d97473344489dfc(target, origin = "*") {
    return (type, data)=>new Promise((resolve)=>{
            const UID = (0, $9b05bcda60cc529c$export$89912e019eef22aa)();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener("message", handler);
            }
            globalThis.addEventListener("message", handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $19ed8aeb7905a045$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener("statechange", function() {
                if (this.state === "installed" && navigator.serviceWorker.controller) resolve(this);
            });
    });
}


var $7a08303ce13c49c5$exports = {};

$parcel$export($7a08303ce13c49c5$exports, "PageVector", function () { return $7a08303ce13c49c5$export$1b88f6b6d432a52a; });
$parcel$export($7a08303ce13c49c5$exports, "getSwipeVector", function () { return $7a08303ce13c49c5$export$b70f6380221b1350; });
$parcel$export($7a08303ce13c49c5$exports, "durationOf", function () { return $7a08303ce13c49c5$export$75d6cbe4503e149; });
$parcel$export($7a08303ce13c49c5$exports, "watchMotion", function () { return $7a08303ce13c49c5$export$b2618d51188815c2; });
$parcel$export($7a08303ce13c49c5$exports, "transitIn", function () { return $7a08303ce13c49c5$export$490814474ddbb428; });
$parcel$export($7a08303ce13c49c5$exports, "animateIn", function () { return $7a08303ce13c49c5$export$3ea201dffb50dfef; });
$parcel$export($7a08303ce13c49c5$exports, "transitOut", function () { return $7a08303ce13c49c5$export$d1012c7198c6b460; });
$parcel$export($7a08303ce13c49c5$exports, "animateOut", function () { return $7a08303ce13c49c5$export$a35a418b7b17958e; });

class $7a08303ce13c49c5$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? "right" : "left";
            case YL:
                return YD > 0 ? "forward" : "backward";
            case ZL:
                return ZD > 0 ? "up" : "down";
        }
    }
}
function $7a08303ce13c49c5$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $7a08303ce13c49c5$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $7a08303ce13c49c5$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === "animation" ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === "ms" ? 1 : 1000);
}
function $7a08303ce13c49c5$export$b2618d51188815c2(type, element) {
    return Promise.race([
        (0, $19ed8aeb7905a045$export$1d1d2ed6b55cf67f)(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $7a08303ce13c49c5$export$75d6cbe4503e149(type, element)))
    ]);
}
function $7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $7a08303ce13c49c5$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $7a08303ce13c49c5$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = "none";
}
function $7a08303ce13c49c5$export$490814474ddbb428(element, className, display = "block") {
    return $7a08303ce13c49c5$var$fadeIn("transition", element, className, display);
}
function $7a08303ce13c49c5$export$3ea201dffb50dfef(element, className, display = "block") {
    return $7a08303ce13c49c5$var$fadeIn("animation", element, className, display);
}
function $7a08303ce13c49c5$export$d1012c7198c6b460(element, className, remove) {
    return $7a08303ce13c49c5$var$fadeOut("transition", element, className, remove);
}
function $7a08303ce13c49c5$export$a35a418b7b17958e(element, className, remove) {
    return $7a08303ce13c49c5$var$fadeOut("animation", element, className, remove);
}


var $69bd9f0117925302$exports = {};

$parcel$export($69bd9f0117925302$exports, "describe", function () { return $69bd9f0117925302$export$cd5450f3a47e3789; });
$parcel$export($69bd9f0117925302$exports, "it", function () { return $69bd9f0117925302$export$3486a10f30cf1ee4; });

async function $69bd9f0117925302$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $69bd9f0117925302$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = "    " + title;
    console.time(title);
    async function timeOut() {
        await (0, $bb23e0c794fefbef$export$e772c8ff12451969)(secondsOut);
        throw new RangeError("Timed out");
    }
    try {
        return await Promise.race([
            userCase((status)=>console.assert(status, title)),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}




export {$9b05bcda60cc529c$export$61cc6ed0f143570b as likeNull, $9b05bcda60cc529c$export$dd1bc94b04021eeb as isEmpty, $9b05bcda60cc529c$export$a09f818797e212c4 as classNameOf, $9b05bcda60cc529c$export$170f4e08cad8229d as assertInheritance, $9b05bcda60cc529c$export$2a489b3f92f4996a as proxyPrototype, $9b05bcda60cc529c$export$67a6ce548ae77071 as isUnsafeNumeric, $9b05bcda60cc529c$export$a48f0734ac7c2329 as byteLength, $9b05bcda60cc529c$export$3f34ca2fef821bbd as toHyphenCase, $9b05bcda60cc529c$export$86f54f62aa7a7514 as toCamelCase, $9b05bcda60cc529c$export$89912e019eef22aa as uniqueID, $9b05bcda60cc529c$export$1c8ba402144543e5 as objectFrom, $9b05bcda60cc529c$export$2ddabb89308e1a22 as DiffStatus, $9b05bcda60cc529c$export$14527669107aa301 as diffKeys, $9b05bcda60cc529c$export$3f063810d7bf01bd as groupBy, $9b05bcda60cc529c$export$b5a4d6f439a5044d as likeArray, $9b05bcda60cc529c$export$b119cc7e1840e59c as isTypedArray, $9b05bcda60cc529c$export$7b85fd78dd236198 as makeArray, $9b05bcda60cc529c$export$697c3df919c0e61a as splitArray, $9b05bcda60cc529c$export$e6b5ff3168b5942b as findDeep, $9b05bcda60cc529c$export$1d012a0dff3dab06 as countBy, $9b05bcda60cc529c$export$69a3209f1a06c04d as cache, $9b05bcda60cc529c$export$86c18c6347f4a8c4 as createAsyncIterator, $9b05bcda60cc529c$export$dce9414bed0662c as mergeStream, $9b05bcda60cc529c$export$271f7c16f175f804 as ByteSize, $6a9944941b4c1893$export$8a63f25cc62965f1 as sum, $6a9944941b4c1893$export$e1f36757ecda301d as averageOf, $6a9944941b4c1893$export$8e694e1eafd55acb as varianceOf, $6a9944941b4c1893$export$57d7c52a66287430 as standardDeviationOf, $6a9944941b4c1893$export$2b4693832ca3ce16 as hypotenuseOf, $6a9944941b4c1893$export$5b784e078da1ce6 as carryFloat, $6a9944941b4c1893$export$17ec9c9f4f23588c as fixFloat, $6a9944941b4c1893$export$595dbf49c602a1f as Scalar, $f872d8bba1c0f79f$export$c489aa6f7fd82b1a as Second, $f872d8bba1c0f79f$export$cbd942915f33be50 as Minute, $f872d8bba1c0f79f$export$9b886f8493244014 as Quarter, $f872d8bba1c0f79f$export$e99cbb807a5bb10d as Hour, $f872d8bba1c0f79f$export$7a9a31a911eb9a20 as Day, $f872d8bba1c0f79f$export$fca4f8121099df57 as Week, $f872d8bba1c0f79f$export$6ce2f08d515512 as Year, $f872d8bba1c0f79f$export$951c8378cdfec6e6 as Month, $f872d8bba1c0f79f$export$1a4097b876a13bf7 as Season, $f872d8bba1c0f79f$export$d9bcbd5e1ff81430 as Timestamp, $f872d8bba1c0f79f$export$506c8e8f8c8edda as diffTime, $f872d8bba1c0f79f$export$3ae94a2503e890a1 as formatDate, $f872d8bba1c0f79f$export$62ad822b3a5fd9a0 as changeMonth, $ba0e5dc395660a7c$export$27924e57e9afff7f as parseJSON, $ba0e5dc395660a7c$export$7ea17d45ecdcf634 as toJSValue, $ba0e5dc395660a7c$export$bb8626e4916f587b as parseTextTable, $083124ac4b1a50a0$export$71e6483fc2b024eb as isXDomain, $083124ac4b1a50a0$export$eb9b2aadbe449a20 as parseURLData, $083124ac4b1a50a0$export$13397a83aa5915d6 as buildURLData, $083124ac4b1a50a0$export$fd89523fba250fa4 as blobOf, $083124ac4b1a50a0$export$504fbde693c1771c as blobFrom, $50872bf213056663$export$1b9ac4d3de3ffd2e as makeCRC32, $50872bf213056663$export$d51f3b55e8d1aa73 as makeSHA, $3e0a089cc13f69ad$export$f5a4056b78c72efa as XMLNamespace, $3e0a089cc13f69ad$export$2ee022bbbc550b25 as templateOf, $3e0a089cc13f69ad$export$a549dd5cef7f8327 as elementTypeOf, $3e0a089cc13f69ad$export$8eece510bcb9c62c as isHTMLElementClass, $3e0a089cc13f69ad$export$b8a1af58c024fefd as tagNameOf, $3e0a089cc13f69ad$export$a2cf0d4bb6e06de4 as isDOMReadOnly, $3e0a089cc13f69ad$export$d66b332881d9723f as parseDOM, $3e0a089cc13f69ad$export$b0709844452f8b6b as stringifyDOM, $3e0a089cc13f69ad$export$5118471ee5d5453b as walkDOM, $3e0a089cc13f69ad$export$be4650432daa84fd as getVisibleText, $3e0a089cc13f69ad$export$578e38b4a3e0b255 as splitPages, $3e0a089cc13f69ad$export$7cd14c57bbb84350 as importCSS, $3e0a089cc13f69ad$export$5100419dfae0456d as stringifyCSS, $3e0a089cc13f69ad$export$28d9d24a8cd0ffc2 as insertToCursor, $3e0a089cc13f69ad$export$3f99968195accfaf as scrollTo, $3e0a089cc13f69ad$export$eafdbaa868ea9975 as watchScroll, $3e0a089cc13f69ad$export$36a0c1ca2ae264fa as watchVisible, $3e0a089cc13f69ad$export$86d7c59254d6a2c9 as formToJSON, $bb23e0c794fefbef$export$e772c8ff12451969 as sleep, $bb23e0c794fefbef$export$57207d71b8c929c8 as asyncLoop, $19ed8aeb7905a045$export$10b1921597150314 as delegate, $19ed8aeb7905a045$export$3e2b244719956741 as documentReady, $19ed8aeb7905a045$export$1d1d2ed6b55cf67f as promisify, $19ed8aeb7905a045$export$2155c0b5a4b77fb8 as createMessageServer, $19ed8aeb7905a045$export$9d97473344489dfc as createMessageClient, $19ed8aeb7905a045$export$d635d04af3887bbe as serviceWorkerUpdate, $7a08303ce13c49c5$export$1b88f6b6d432a52a as PageVector, $7a08303ce13c49c5$export$b70f6380221b1350 as getSwipeVector, $7a08303ce13c49c5$export$75d6cbe4503e149 as durationOf, $7a08303ce13c49c5$export$b2618d51188815c2 as watchMotion, $7a08303ce13c49c5$export$490814474ddbb428 as transitIn, $7a08303ce13c49c5$export$3ea201dffb50dfef as animateIn, $7a08303ce13c49c5$export$d1012c7198c6b460 as transitOut, $7a08303ce13c49c5$export$a35a418b7b17958e as animateOut, $69bd9f0117925302$export$cd5450f3a47e3789 as describe, $69bd9f0117925302$export$3486a10f30cf1ee4 as it};
//# sourceMappingURL=index.esm.js.map
